export default "__VITE_ASSET__DG$spFKP__"